var _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgItalicIcon = function SvgItalicIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 4,
    x2: 10,
    y2: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 5,
    y2: 20
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 4,
    x2: 9,
    y2: 20
  })));
};
export default SvgItalicIcon;